// extracted by mini-css-extract-plugin
module.exports = {"melodyVideo":"Bd","landingPageVideo":"Cd","play":"Dd","iframeVideo":"Ed","playHidden":"Fd","playVisible":"Gd","fullwidth":"Hd"};